import type { BuildQuote, StartBuildResult } from '@app/shared';
import type { Dictionary } from '../i18n';

/** The build part of «Формат и текст» (carousel) and «Озвучка» (reel): the price parts and the answer of «Собрать». */

/** «рилс «Схема» 30 + озвучка клоном 5» — only when the price has more than one part. */
export function priceParts(quote: BuildQuote, t: Dictionary): string | null {
  if (quote.lines.length < 2) return null;
  return quote.lines.map((l) => `${t.render.quoteLine[l.code]} ${l.amount}`).join(' + ');
}

export type BuildAnswer =
  | { kind: 'navigate'; to: string }
  | { kind: 'note'; text: string; link: { to: string; label: string } | null }
  | { kind: 'reload' };

/**
 * What the screen does with the answer of «Собрать». `canBuy`: a pack is on sale, so the
 * «Не хватает кредитов» link says «Купить»; with every method off it stays «Кредиты».
 */
export function answerOf(
  result: StartBuildResult,
  draftId: number,
  t: Dictionary,
  opts: { canBuy?: boolean } = {},
): BuildAnswer {
  const r = t.render;
  switch (result.kind) {
    case 'ok':
      return { kind: 'navigate', to: `/renders/${result.job.id}` };
    case 'busy':
      return { kind: 'navigate', to: `/renders/${result.jobId}` };
    case 'no_credits':
      return { kind: 'note', text: r.noCredits(result.price, result.balance), link: { to: '/credits', label: opts.canBuy ? r.buyCredits : r.toCredits } };
    case 'form':
      return { kind: 'note', text: r.formIssues, link: { to: `/drafts/${draftId}`, label: r.toText } };
    case 'no_signature':
      return { kind: 'note', text: r.needSignature, link: { to: '/settings', label: r.toSettings } };
    case 'no_voice':
      return { kind: 'note', text: r.needVoice, link: null };
    case 'voice_limit':
      return { kind: 'note', text: result.reason === 'per_draft' ? t.voiceScreen.takesOver : t.voiceScreen.dailyOver, link: null };
    case 'voice_busy':
      return { kind: 'note', text: t.voiceScreen.voiceBusy, link: null };
    case 'not_approved':
    case 'not_found':
      return { kind: 'note', text: r.notApproved, link: { to: `/drafts/${draftId}`, label: r.toText } };
    case 'style_unknown':
      return { kind: 'reload' };
  }
}
